import { getCityInfo } from '@max/meituan-uni-city';
import { reportJSInfo } from '@max/meituan-uni-report';
const isMRN = false;
import { getPlatformType, isDianpingAppOrWebview, PlatformType } from '@nibfe/mkt-env-api';
const isPlatformDP = isDianpingAppOrWebview() || getPlatformType() === PlatformType.dpMinaWebview;
const DEFAULT_CITY_ID = isPlatformDP ? 2 : 1;
export const getLocationCityId = () => {
    return new Promise(resolve => {
        getCityInfo().then(res => {
            var _a;
            resolve((_a = res === null || res === void 0 ? void 0 : res.id) !== null && _a !== void 0 ? _a : -1);
        }).catch(error => {
            reportJSInfo({
                secCategory: 'apiGetInfoError',
                level: 'info',
                content: 'mcp-tex-city-around-selection getLocationCityId 出错',
                tags: {
                    errorInfo: JSON.stringify(error)
                }
            }).catch();
            resolve(-1);
        });
    });
};
export function getActuralCityId(props) {
    var _a, _b;
    const { ctx } = props;
    const runtimeInfo = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo;
    const queryParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.queryParams;
    const commonParams = runtimeInfo === null || runtimeInfo === void 0 ? void 0 : runtimeInfo.commonParams;
    // 优先从查询参数获取城市id
    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.cityId) {
        console.log('get cityid from jumpUrl', queryParams.cityId);
        return {
            cityId: Number(queryParams.cityId),
            type: 'queryParams'
        };
    }
    // 获取小环境城市
    // 从美团首页获取城市
    if ((_a = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _a === void 0 ? void 0 : _a.cityId) {
        console.log('get cityid from commonParams', commonParams.cityInfo.cityId);
        return {
            cityId: Number(commonParams.cityInfo.cityId),
            type: 'homePage'
        };
    }
    // 从定位获取城市
    if ((_b = commonParams === null || commonParams === void 0 ? void 0 : commonParams.cityInfo) === null || _b === void 0 ? void 0 : _b.locCityId) {
        console.log('get loc cityId from commonParams', commonParams.cityInfo.locCityId);
        return {
            cityId: Number(commonParams.cityInfo.locCityId),
            type: 'locCityId'
        };
    }
    return {
        cityId: DEFAULT_CITY_ID,
        type: 'default'
    };
}
